import type { ServerSideBlotterSearchRequest } from 'apiConnector/blotters';
import { connect } from 'react-redux';
import type { ActivityFilter, DateFilter, PlatformFilter, ProductFilter } from 'state/blotters/common/blotter.model';
import {
  quoteBlotterAdvancedFiltersToggled,
  quoteBlotterFilterChanged,
  quoteBlotterManualRefreshRequested,
} from 'state/blotters/quote';
import {
  getIsUserInternal,
  getQuoteBlotterFilters,
  getQuoteBlotterIsFetchingFailed,
  getQuoteBlotterLoading,
  isQuoteBlotterEndDateFilterInThePast,
} from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export type FilterOwnProps = {
  lastBlotterRequest: ServerSideBlotterSearchRequest | undefined;
};

export interface FilterStateProps {
  quickSearchTerm: string;
  dateFilter: DateFilter;
  activityFilter: ActivityFilter;
  productFilter: ProductFilter;
  platformFilter: PlatformFilter;
  deskFilter: number | null;
  advancedFilters: boolean;
  error: boolean;
  loading: boolean;
  isInternal: boolean;
  isEndDateInThePast: boolean;
}

export interface FilterDispatchProps {
  onFullTextSearchChanged(value?: string): void;
  onDateFilterChanged(value: DateFilter): void;
  onActivityFilterChanged(value: ActivityFilter): void;
  onProductFilterChanged(product: ProductFilter): void;
  onPlatformFilterChanged(platform: PlatformFilter): void;
  onDeskFilterChanged(desk: number | null): void;
  onAdvancedFilterToggled(): void;
  onManualRefresh(): void;
}

export const mapStateToProps = (state: AppState): FilterStateProps => {
  const isInternal = getIsUserInternal(state);
  const { quickSearchTerm, dateFilter, activityFilter, productFilter, platformFilter, advancedFilters, deskFilter } =
    getQuoteBlotterFilters(state);
  const isFetchingFailed = getQuoteBlotterIsFetchingFailed(state);
  const isEndDateInThePast = isQuoteBlotterEndDateFilterInThePast(state);
  const loading = getQuoteBlotterLoading(state);
  return {
    quickSearchTerm,
    dateFilter,
    activityFilter,
    productFilter,
    platformFilter,
    deskFilter,
    advancedFilters,
    error: isFetchingFailed,
    loading,
    isInternal,
    isEndDateInThePast,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): FilterDispatchProps => ({
  onFullTextSearchChanged(value) {
    dispatch(quoteBlotterFilterChanged('quickSearchTerm', value || ''));
  },
  onDateFilterChanged(dateFilter) {
    dispatch(quoteBlotterFilterChanged('dateFilter', dateFilter));
  },
  onActivityFilterChanged(activity) {
    dispatch(quoteBlotterFilterChanged('activityFilter', activity));
  },
  onProductFilterChanged(product) {
    dispatch(quoteBlotterFilterChanged('productFilter', product));
  },
  onPlatformFilterChanged(platform) {
    dispatch(quoteBlotterFilterChanged('platformFilter', platform));
  },
  onDeskFilterChanged(desk) {
    dispatch(quoteBlotterFilterChanged('deskFilter', desk));
  },
  onAdvancedFilterToggled() {
    dispatch(quoteBlotterAdvancedFiltersToggled());
  },

  onManualRefresh() {
    dispatch(quoteBlotterManualRefreshRequested());
  },
});

export const connectFilterComponent = connect(mapStateToProps, mapDispatchToProps);
